// Shared perizinan helpers
export function todayISO() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

export function formatIsoDate(s) {
  if (!s) return "—";
  try {
    const d = new Date(s);
    if (isNaN(d.getTime())) return s;
    return d.toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" });
  } catch { return s; }
}

export function buildWaMessage({ nama_lengkap, alasan, tanggal_pengajuan, tanggal_rencana_kembali }) {
  return `Assalamualaikum wr.wb .. saya ${nama_lengkap} mengajukan izin untuk : ${alasan} , pada tanggal *${tanggal_pengajuan}* dan Kembali pada tanggal *${tanggal_rencana_kembali}* .. mohon untuk segera diproses, terima kasih`;
}

export function buildWaLink(wa_number, message) {
  const digits = String(wa_number || "").replace(/[^0-9]/g, "");
  if (!digits) return null;
  return `https://wa.me/${digits}?text=${encodeURIComponent(message)}`;
}
